function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import icTick from 'assets/svg/ic_tick.svg';

const Checkbox = ({
  className,
  check,
  onToggle,
  disabled,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(styles.box, !check && styles.hide, disabled && styles.disabled, className),
    onClick: () => onToggle === null || onToggle === void 0 ? void 0 : onToggle(!check)
  }, props), /*#__PURE__*/React.createElement("img", {
    className: classNames(styles.check, !check && styles.hide, disabled && styles.disabled),
    src: icTick
  }));
};

export default Checkbox;